
module.exports = (v) => String.fromCharCode.apply(null, new Uint16Array(v));
